export const generateRandomEmail = (): string => {
  return `circlestest@${Math.random()}.adasd`;
};
